<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-button
      class="mb-4"
      variant="primary"
      size="xl"
      v-auth="`update`"
      @click="save()"
    >
      保存
    </b-button>

    <b-form-checkbox
      switch
      size="lg"
      value=1
      unchecked-value=0
      v-model.number="billDownloadConfig"
      v-auth="`update`"
    >
      前台是否開啟下載帳單功能
    </b-form-checkbox>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import configApi from "@/models/API/configApi";

export default {
  name: 'config',
  components: {
    BreadCrumb,
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '設定', url: '', isActive: true },
          { name: '環境設定', url: '', isActive: false }
        ]
      },
      billDownloadConfig: 0
    }
  },
  mounted() {
    this.configApi = new configApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.getConfig();
    },
    // 查詢環境設定
    getConfig() {
      this.configApi.getConfig((response) => {
        const res = response.data;

        this.billDownloadConfig = res.data[0].value;
      })
    },
    // 更新環境設定
    save() {
      const params = {
        'value': this.billDownloadConfig
      }
      this.configApi.updateConfig((response) => {
        const res = response.data;

        if (res.code === 0) {
          this.getConfig();

          const result = { message: `更新成功`, title: '環境設定' };

          this.configApi.toast(() => {}, result, true);
        }
      }, 1,params)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/config.vue